import BaseStore from './BaseStore'

export class DocumentStore extends BaseStore {
  constructor() {
    super()
    this.endpoint = 'documents'
  }
}

export default new DocumentStore()


// WEBPACK FOOTER //
// ./src/stores/DocumentStore.js